module.exports = __webpack_public_path__ + "img/Twitter-logo.045bc4b5.svg";